import { Directive, ElementRef, inject, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[lvIcon]'
})
export class IconDirective implements OnInit {
  lastIcon: string;

  private element = inject(ElementRef);
  private renderer = inject(Renderer2);

  get native(): HTMLElement {
    return this.element.nativeElement;
  }

  @Input() set lvIcon(value: string) {
    if (this.lastIcon) {
      this.renderer.removeClass(this.native, this.lastIcon);
    }
    this.lastIcon = `fa-${value}`;
    this.addClass(this.lastIcon);
  }

  addClass(klass: string) {
    this.renderer.addClass(this.native, klass);
  }

  ngOnInit() {
    this.addClass('fa');
  }
}
